import { Link } from 'react-router-dom';
import { categoryArticles } from '@/mocks/articles';
import type { categoryMeta } from '@/mocks/articles';

interface ArticleGridProps {
  slug: string;
}

export default function ArticleGrid({ slug }: ArticleGridProps) {
  const articles = categoryArticles[slug] || [];

  if (articles.length === 0) {
    return (
      <section className="bg-background-50 py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-background-100 flex items-center justify-center">
            <i className="ri-inbox-line text-foreground-300 text-2xl w-8 h-8 flex items-center justify-center"></i>
          </div>
          <h2 className="text-xl font-heading font-bold text-foreground-500">暂无内容</h2>
          <p className="mt-2 text-sm text-foreground-400">该分类下暂时还没有内容，请稍后再来</p>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <p className="text-sm font-bold text-foreground-400 uppercase tracking-wider">
              最新内容
            </p>
            <h2 className="text-2xl font-heading font-bold text-foreground-900 mt-1">
              共 {articles.length} 条吃瓜内容
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group cursor-pointer"
            >
              <div className="bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                </div>
                <div className="p-5">
                  {article.category && (
                    <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-bold whitespace-nowrap mb-3 inline-block">
                      {article.category}
                    </span>
                  )}
                  <h3 className="text-base font-heading font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2 mt-2">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.summary}
                  </p>
                  <div className="mt-4 flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                      {article.views >= 10000
                        ? `${(article.views / 10000).toFixed(1)}万`
                        : article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-message-2-line w-3.5 h-3.5 flex items-center justify-center"></i>
                      {article.comments}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}